export enum AccountType {
  CURRENT = 'current',
  WAFI = 'wafi',
}
